<main id="main-content" class="ds-product-page ds-product-page--narrow">
  <p class="eyebrow">{{ 'candidate.eyebrow' | t }}</p>
  <h1>{{ 'candidate.title' | t }}</h1>
  <p class="lede">{{ 'candidate.lede' | t }}</p>

  @if (error()) {
    <p class="error" role="alert">{{ error() }}</p>
  }

  @if (!user()) {
    <form (ngSubmit)="login()">
      <h2>{{ 'common.developmentLogin' | t }}</h2>
      <label for="candidate-email">{{ 'common.email' | t }}</label>
      <input dsInput id="candidate-email" type="email" [formControl]="email" autocomplete="email" />
      <button dsButton type="submit" [disabled]="busy() || email.invalid">
        {{ 'common.continue' | t }}
      </button>
    </form>
  } @else if (!invitation()) {
    <form (ngSubmit)="redeem()">
      <h2>{{ 'candidate.redeemTitle' | t }}</h2>
      <label for="invitation-token">{{ 'candidate.token' | t }}</label>
      <input dsInput id="invitation-token" [formControl]="token" autocomplete="off" />
      <button dsButton type="submit" [disabled]="busy() || token.invalid">
        {{ 'candidate.redeem' | t }}
      </button>
    </form>
  } @else if (!progress()) {
    <section dsCard class="card">
      <h2>{{ invitation()?.campaignName }}</h2>
      <p>{{ 'candidate.organization' | t }}: {{ invitation()?.organizationName }}</p>
      <label class="check">
        <input dsCheckbox type="checkbox" [formControl]="consent" />
        <span>{{ 'candidate.consent' | t }}</span>
      </label>
      <button
        dsButton
        type="button"
        (click)="acceptAndStart()"
        [disabled]="busy() || consent.invalid"
      >
        {{ 'candidate.accept' | t }}
      </button>
    </section>
  } @else if (progress()?.completed) {
    <section class="card completion" role="status">
      <h2>{{ 'candidate.complete' | t }}</h2>
      <p>{{ progress()?.message }}</p>
      <p>{{ 'candidate.answered' | t }}: {{ progress()?.answeredItems }}</p>
    </section>
  } @else if (progress()?.currentItem; as item) {
    <section class="card item" [attr.aria-labelledby]="'item-' + item.sequence">
      <p class="progress">Item {{ item.sequence }} · {{ item.domain }}</p>
      <h2 [id]="'item-' + item.sequence">{{ item.prompt }}</h2>
      @if (item.safeSvg) {
        <div class="visual" [innerHTML]="item.safeSvg"></div>
      }
      <div class="options">
        @for (option of item.options; track option.code) {
          <button dsButton type="button" (click)="answer(option.code)" [disabled]="busy()">
            <span>{{ option.code }}</span
            >{{ option.text }}
          </button>
        }
      </div>
      <p class="note">{{ 'candidate.saved' | t }}</p>
    </section>
  }
</main>
